// removed by extract-text-webpack-plugin
module.exports = {" _key":"widgets-web/base","textDecorationUnderline":"_3d2K0ca9","textDecorationLineThrough":"_2drmpP-G","textDecorationOverline":"_33ZKVUj_"};


//////////////////
// WEBPACK FOOTER
// ./src/common/base.m.css
// module id = ./src/common/base.m.css
// module chunks = badge